import {
  MISSINGPROMPTS_REQUEST,
  MISSINGPROMPTS_SUCCESS,
  MISSINGPROMPTS_FAILURE,
} from "../types/missingPrompts.types";

const initalstate = {
  data: [],
  error: "",
  loading: false,
};

export const MissingPromptsReducer = (state = initalstate, action) => {
  switch (action.type) {
    case MISSINGPROMPTS_REQUEST:
      return { ...state, loading: true };
    case MISSINGPROMPTS_SUCCESS:
      return { ...state, data: action.payload, loading: false };
    case MISSINGPROMPTS_FAILURE:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};